import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { VhImage, VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
// import { FunctionService } from '../../../services/function.service';
// import { ManageLibraryComponent } from 'src/app/admin/manage-library/manage-library.component';
import { FunctionService} from 'vhobjects-service/src/services';
import { ManageLibraryComponent } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';

@Component({
  selector: 'app-video-upload',
  templateUrl: './video-upload.component.html',
  styleUrls: ['./video-upload.component.scss']
})
export class AtwVideoUploadConfig implements OnInit {
  isCollapsed: boolean = false;
  isShowConfirmPopup: boolean = false;
  isConfirmLoading: boolean = false; // biến kiểm tra khi đang xử lý dữ liệu
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  backgroundColor: any = [];
  fonts = [];
  currentViewAll: any = {};
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  effect_hover = [];
  isApplyShadow: boolean = false; // Cho phép thêm | chỉnh sửa bóng
  effect_hover_data: any = {};
  @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại
  // Mảng chứa nội dung các dropdown cài đặt
  style_fields = [
    {
      title: 'Thông số cơ bản',
      index: 1,
      isDrop: false,
    },
    {
      title: 'Bộ lọc hình ảnh',
      index: 2,
      isDrop: false,
    },
    {
      title: 'Độ bao phủ',
      index: 3,
      isDrop: false,
    },
    {
      title: 'Bo tròn',
      index: 4,
      isDrop: false,
    },
    {
      title: 'Đổ bóng',
      index: 5,
      isDrop: false,
    },
    {
      title: 'Cấu hình chi tiết hiệu ứng',
      index: 6,
      isDrop: false,
    },
    {
      title: 'Biến đổi',
      index: 7,
      isDrop: false,
    },
    {
      title: 'Thêm liên kết',
      index: 8,
      isDrop: false,
    },
  ];
  // Mảng chứa nội dung các kiểu bóng định sẵn
  shadow_styles: any = [
    {
      name: 'Kiểu 1',
      objectChoosing: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
      img: '/assets/root/images/system/imgs/box-shadow-1.jpg',
    },
    {
      name: 'Kiểu 2',
      objectChoosing: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
      img: '/assets/root/images/system/imgs/box-shadow-2.jpg',
    },
    {
      name: 'Kiểu 3',
      objectChoosing: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
      img: '/assets/root/images/system/imgs/box-shadow-3.jpg',
    },
    {
      name: 'Kiểu 4',
      objectChoosing:
        'rgba(0, 0, 0, 0.16) 0px 1px 4px, rgb(51, 51, 51) 0px 0px 0px 3px',
      img: '/assets/root/images/system/imgs/box-shadow-4.jpg',
    },
    {
      name: 'Kiểu 5',
      objectChoosing:
        'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
      img: '/assets/root/images/system/imgs/box-shadow-5.jpg',
    },
    {
      name: 'Kiểu 6',
      objectChoosing:
        'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
      img: '/assets/root/images/system/imgs/box-shadow-6.jpg',
    },
    {
      name: 'Kiểu 7',
      objectChoosing:
        'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
      img: '/assets/root/images/system/imgs/box-shadow-7.jpg',
    },
    {
      name: 'Kiểu 8',
      objectChoosing: 'rgb(38, 57, 77) 0px 20px 30px -10px',
      img: '/assets/root/images/system/imgs/box-shadow-8.jpg',
    },
    {
      name: 'Kiểu 9',
      objectChoosing:
        'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
      img: '/assets/root/images/system/imgs/box-shadow-9.jpg',
    },
    {
      name: 'Kiểu 10',
      objectChoosing:
        'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px',
      img: '/assets/root/images/system/imgs/box-shadow-10.jpg',
    },
    {
      name: 'Kiểu 11',
      objectChoosing:
        'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
      img: '/assets/root/images/system/imgs/box-shadow-11.jpg',
    },
    {
      name: 'Kiểu 12',
      objectChoosing:
        'rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px',
      img: '/assets/root/images/system/imgs/box-shadow-12.jpg',
    },
    {
      name: 'Kiểu 13',
      objectChoosing:
        'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
      img: '/assets/root/images/system/imgs/box-shadow-13.jpg',
    },
    {
      name: 'Kiểu 14',
      objectChoosing:
        'rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px',
      img: '/assets/root/images/system/imgs/box-shadow-14.jpg',
    },
    {
      name: 'Kiểu 15',
      objectChoosing: 'rgba(0, 0, 0, 0.45) 0px 25px 20px -20px',
      img: '/assets/root/images/system/imgs/box-shadow-15.jpg',
    },
  ];

  id_subproject: any;
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private dialog: MatDialog,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    private vhImage: VhImage,
    private nzMessageService: NzMessageService,
    private matdialog: MatDialog,
    private functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;

    // Kiểm tra nếu chưa có config thì thêm để người dùng không cần xóa thêm lại
    if (!this.config.hasOwnProperty('position_onscroll')) {
      this.config.position_onscroll = {
        type: 0,
        top: 0,
      };
    }

    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/image.json'),
      this.http.get('assets/background-colors/background-colors.json'),
    ]).subscribe(([effects, background_colors]: any) => {
      this.effect_hover = effects;
      this.backgroundColor = background_colors;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
    });
  }

  ngOnChanges({ device }: SimpleChanges): void {
    if (this.effect_hover)
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
  }

  /** Xử lí xoay lật
   * @param axis : Lật theo trục 'x' | 'y' | 'z' | '-z'
   */
  handleSetTransform(axis) {
    switch (axis) {
      case 'x': // ---Lật dọc
        if (this.config['transform'].transform_rotateX < 360) {
          this.config['transform'].transform_rotateX += 180;
          this.class['video'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        } else {
          this.config['transform'].transform_rotateX -= 360;
          this.class['video'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case 'y': // ---Lật ngang
        if (this.config['transform'].transform_rotateY < 360) {
          this.config['transform'].transform_rotateY += 180;
          this.class['video'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        } else {
          this.config['transform'].transform_rotateY -= 360;
          this.class['video'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case '-z': // --- Xoay trái
        if (this.config['transform'].transform_rotateZ > -360) {
          this.config['transform'].transform_rotateZ -= 45;
          this.class['video'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case 'z': // --- Xoay phải
        if (this.config['transform'].transform_rotateZ < 360)
          this.config['transform'].transform_rotateZ += 45;
        this.class['video'].transform =
          'rotateX(' +
          this.config['transform'].transform_rotateX +
          'deg) ' +
          'rotateY(' +
          this.config['transform'].transform_rotateY +
          'deg) ' +
          'rotateZ(' +
          this.config['transform'].transform_rotateZ +
          'deg) ' +
          'skewX(' +
          this.config['transform'].transform_skewX +
          'deg) ' +
          'skewY(' +
          this.config['transform'].transform_skewY +
          'deg) ';
        break;
      default:
    }
    this.updateObject();
  }
  //Hàm cập nhật giá trị transform
  SetTransform() {
    this.class['video'].transform =
      'rotateX(' +
      this.config['transform'].transform_rotateX +
      'deg) ' +
      'rotateY(' +
      this.config['transform'].transform_rotateY +
      'deg) ' +
      'rotateZ(' +
      this.config['transform'].transform_rotateZ +
      'deg) ' +
      'skewX(' +
      this.config['transform'].transform_skewX +
      'deg) ' +
      'skewY(' +
      this.config['transform'].transform_skewY +
      'deg) ';
  }
  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => { });
  }
  /** UPLOAD IMAGE */
  openUpload() {
    if (isPlatformBrowser(this.platformId))  document.getElementById('upload').click();
    // inputVal;
  }
  //Lưu hình ảnh
  saveVideo() {
    this.nzMessageService.success('Lưu video thành công');
    this.updateStaticData();
  }
  onUpload(e) {
    const file = e.target.files[0];
    if (file) {
      this.vhImage.getImageFromDesktop(
          file,
          'videos/design/objects',
          this.objectChoosing.staticdata.src || null,
          2000000
        )
        .then(
          (rsp: any) => {
            if (rsp.vcode === 0) {
              this.objectChoosing.staticdata.src = rsp.data;
              this.saveVideo();
              this.functionService.createMessage(
                'success',
                'Video đã được tải thành công !!!'
              );
            } else {
              this.functionService.createMessage(
                'error',
                `Tải video thất bại! Lý do: ${rsp.message}`
              );
            }
          },
          (error) => {
            // this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
          }
        );
    }
    this.config.video['is_load_video'] = true;
  }
  /**
   * update trường mobile_portrait_hidden or desktop_hidden cho object
   * @param value
   */
  customize = [];
  /**
   *Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => { });
  }
  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
        [this.device + '_config']: this.config,
        staticdata: this.staticdata,
      })
      .then((bool: any) => { });
  }
  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => { });
  }
  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
  };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  /**
   * bắt sk thay đổi loại animation để show ra danh sách animation phù hợp
   */
  // changeTypeAnimation() {
  //   this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata.animation_type)
  // }

  /** Áp dụng đổ bóng
   *   * -> xử lí dữ liệu bóng -> css:  box-shadow: `x y blur color`
   */
  handleSetShadow() {
    if (this.config.check_shadow == false)
      this.class['video__iframe']['box-shadow'] = 'none';
    else {
      this.class['video__iframe'].transform = 0.8;
      this.class['video__iframe'][
        'box-shadow'
      ] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_color}`;
    }
    this.updateObject();
  }
  /** Xử lí đổ bóng
   * -> xử lí dữ liệu bóng -> css:  object-position: `x y blur color`
   */
  handleSetPositionShadow() {
    this.class['video__iframe'][
      'box-shadow'
    ] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_width}px ${this.config['box-shadow'].box_shadow_color}`;
    this.updateObject();
  }
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }
  /**
   * remove link khi click vào nút x
   */
  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData();
  }

  public urlBackgroundImage = ''; // Giá trị đường dẫn của background-video
  /** Hàm sẽ thực hiện disable các option khi lựa chọn tải ảnh nền cho frame
   *
   * @param valueItem
   * @returns
   */
  checkDisableUploadImage(valueItem: any) {
    if (this.config['video'].is_upload_video === valueItem) return false;
    return true;
  }
  path = '/images';
  /**
   * Hàm xử lý lấy ảnh ở thư viện
   */
  openLibrary() {
    const dialogRef = this.matdialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path ? this.path : '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        this.objectChoosing.staticdata.img = data.href;
        this.saveVideo();
      }
      this.path = data.path;
    });
  }

  /** Xử lí lưu vị trí ảnh
   * -> xử lí dữ liệu bóng -> css:  object-position: `x y`
   */
  handleSetPositionVideo() {
    this.class['video__iframe'][
      'object-position'
    ] = `-${this.config.video.object_x}px -${this.config.video.object_y}px`;
    this.updateObject();
  }

  //Hàm xử lý scale
  scale() {
    this.class['video__iframe'][
      'transform'
    ] = `scale(${this.class['video__iframe']['transfrom_scale']})`;
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    var effect =
      this.objectChoosing[this.device + '_config']['animation-selected'];
    this.class['video'].transform = '';
    if (effect.id == '000010') {
      this.class['video__iframe']['height'] = '';
    } else if (effect.id == '000007') {
      this.class['video__iframe']['filter'] = '';
    } else {
      this.class['video__iframe']['height'] = '100%';
      this.class['video__iframe']['filter'] =
        'brightness(100%)  contrast(100%)  saturate(100%)   hue-rotate(0deg)   blur(0px)   opacity(100%)   grayscale(0%)';
    }

    this.updateObject();

    this.customize = event;

    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.style_fields[5]);
    }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['video']['width'] = event.width + 'px';
    if (event.height) this.class['video']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  updateCompress() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      compress: this.objectChoosing.compress,
      compress_type: this.objectChoosing.compress_type,
    });
  }

  handleChangeCompressType(event) {
    this.objectChoosing.compress_type = event;
    this.updateCompress();
  }

  handleCancelConfirm() {
    this.isShowConfirmPopup = false;
  }

  /**
   * Lấy hình ảnh từ url đẩy lên server với kích thước hình ko thay đổi
   * */
  handleOkConfirm() {
    this.isConfirmLoading = true;
    const messages = {
      0: 'Upload ảnh thành công!!!',
      1: 'Lỗi import file ảnh!!!',
      2: 'Lỗi upload file ảnh!!!',
      3: 'Không thể upload file ảnh lớn hơn 1Mb!!!',
    };
    setTimeout(() => {
      this.vhImage
        .getImageFromURL(
          this.staticdata.img,
          'images/design/objects',
          this.staticdata.img.includes(this.id_subproject)
            ? this.staticdata.img
            : null
        )
        .then(
          (rsp: any) => {
            //
            if (messages[rsp.vcode]) {
              this.functionService.createMessage(
                rsp.vcode === 0 ? 'success' : 'error',
                messages[rsp.vcode]
              );
            }
            if (rsp) {
              this.staticdata.img = rsp;
              this.updateStaticData();
              this.functionService.createMessage('success', messages[0]);
            }
          },
          (error) => {
            if (error.message && error.message.includes('413')) {
              // Thông báo cho người dùng
              this.functionService.createMessage(
                'error',
                'File ảnh quá lớn, vui lòng chọn file ảnh có dung lượng nhỏ hơn 1Mb'
              );
            } else {
            }
          }
        )
        .finally(() => {
          this.isConfirmLoading = false;
          this.isShowConfirmPopup = false;
        });
    }, 1000);
  }
}
